import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Table,
  Typography,
  ConfigProvider,
} from "antd";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import { Box, Button, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";

const SubTabs = ({
  cardHeading,
  tablist,
  selectedTab,
  tabdata,
  editState,
  rowData,
  colData,
}) => {
  const [expand, setExpand] = useState(1);
  const [value, setValue] = useState(selectedTab);
  const [tabColumns, setTabColumns] = useState([]);
  const [tabRows, setTabRows] = useState([]);
  const [editTab, setEditTab] = useState(0);
  const handletabchange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const foundTabData = tabdata.find((obj) => obj.tab === value);
    if (foundTabData) {
      setTabColumns(foundTabData.columns);
      setTabRows(foundTabData.rows);
    }
  }, [value, tabdata]);

  useEffect(() => {
    setData(originData);
  }, [tabRows]);

  const originData = tabRows.map((_, i) => ({
    key: tabRows[i].key,
    parameter: tabRows[i].parameter,
    quantity: tabRows[i].quantity,
    unit: tabRows[i].unit,
    co2: typeof tabRows[i].quantity === "number" ? tabRows[i].quantity * 1 : 0,
    ch4:
      typeof tabRows[i].quantity === "number" ? tabRows[i].quantity * 27.9 : 0,
    n2o:
      typeof tabRows[i].quantity === "number" ? tabRows[i].quantity * 273 : 0,
    tco2e:
      typeof tabRows[i].quantity === "number"
        ? tabRows[i].quantity * 1 +
          tabRows[i].quantity * 27.9 +
          tabRows[i].quantity * 273
        : 0,
    quantity2: tabRows[i].quantity2,
    tco2e2:
      typeof tabRows[i].quantity === "number"
        ? tabRows[i].parameter === "Purchased Grid Electricity"
          ? tabRows[i].quantity * 0.729
          : 0
        : 0,
    tco2e3: tabRows[i].quantity,
  }));

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode =
      inputType === "number" ? (
        <InputNumber />
      ) : inputType === "number-disabled" ? (
        <InputNumber disabled />
      ) : inputType === "disabled" ? (
        <Input disabled />
      ) : (
        <Input />
      );
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `Please Input ${title}!`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const [form] = Form.useForm();
  const [data, setData] = useState(originData);
  const [editingKey, setEditingKey] = useState("");
  const isEditing = (record) => record.key === editingKey;
  const edit = (record) => {
    editState(1);
    rowData(record);
    colData(tabColumns);
    setEditTab(1);
  };
  const cancel = () => {
    setEditingKey("");
  };
  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        newData[index].co2 = newData[index].quantity * 1;
        newData[index].ch4 = newData[index].quantity * 27.9;
        newData[index].n2o = newData[index].quantity * 273;
        newData[index].tco2e =
          newData[index].co2 + newData[index].ch4 + newData[index].n2o;
        newData[index].tco2e2 =
          newData[index].parameter === "Purchased Grid Electricity"
            ? newData[index].quantity * 0.729
            : 0;
        setData(newData);
        setEditingKey("");
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };
  const columns = [
    ...tabColumns,
    {
      title: "Operation",
      dataIndex: "operation",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record.key)}
              style={{
                marginInlineEnd: 8,
              }}
            >
              Save
            </Typography.Link>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>Cancel</a>
            </Popconfirm>
          </span>
        ) : (
          <Typography.Link
            disabled={editingKey !== ""}
            onClick={() => edit(record)}
          >
            Edit
          </Typography.Link>
        );
      },
    },
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType:
          col.dataIndex === "quantity"
            ? "number"
            : col.dataIndex === "co2" ||
              col.dataIndex === "ch4" ||
              col.dataIndex === "n2o" ||
              col.dataIndex === "tco2e" ||
              col.dataIndex === "tco2e2"
            ? "number-disabled"
            : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (
    <>
      <Typography
        className="config-heading"
        style={{
          fontSize: "20px",
          fontWeight: 400,
          color: "#008CD7",
          padding: "4px",
          marginTop: "20px",
        }}
      >
        {cardHeading}
        <Button
          onClick={() => {
            expand == 1 ? setExpand(0) : setExpand(1);
          }}
        >
          {expand == 1 ? (
            <ExpandLessOutlinedIcon
              style={{
                width: "28px",
                height: "28px",
                fontWeight: 700,
                color: "#008CD7",
              }}
            />
          ) : (
            <ExpandMoreOutlinedIcon
              style={{
                width: "28px",
                height: "28px",
                fontWeight: 700,
                color: "#008CD7",
              }}
            />
          )}
        </Button>
      </Typography>
      {expand == 1 ? (
        <Box style={{ width: "100%", boxSizing: "border-box" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <Tabs
              value={value}
              onChange={handletabchange}
              TabIndicatorProps={{ hidden: true }}
              sx={{
                "& .MuiTabs-indicator": {
                  display: "none",
                  height: "0px",
                  borderRadius: "0px",
                  backgroundColor: "var(--action-button-light)",
                  borderBottom: "1px solid var(--SecondaryBackground)",
                },
                "& .Mui-selected": {
                  color: "var(--LK_BrandBlue_1) !important",
                  fontWeight: "700 !important",
                  backgroundColor: "var(--SecondaryBackground)",
                  borderTop: "1px solid var(--HighlightedText_Stroke)",
                  borderLeft: "1px solid var(--HighlightedText_Stroke)",
                  borderRight: "1px solid var(--HighlightedText_Stroke)",
                  borderBottom: "1px solid var(--SecondaryBackground)",
                },
                "& .MuiTab-root": {
                  padding: "8px 8px 6px 8px !important",
                  margin: "0px !important",
                  minWidth: "63px",
                },
                minHeight: "30px",
                marginBottom: "-1px",
              }}
            >
              {tablist.map((tab, index) => {
                return (
                  <Tab
                    key={index + 1}
                    sx={{
                      minHeight: "30px",
                      height: "30px",
                    }}
                    style={{
                      color: "var(--GreyVariation_2)",
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      fontWeight: 400,
                      lineHeight: "16.75px",
                      textTransform: "capitalize",
                    }}
                    value={tab}
                    label={tab}
                  >
                    {tab}
                  </Tab>
                );
              })}
            </Tabs>
          </div>
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              backgroundColor: "var(--SecondaryBackground)",
              padding: "8px",
              width: "100%",
              boxSizing: "border-box",
              border: "1px solid var(--HighlightedText_Stroke)",
            }}
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                boxSizing: "border-box",
                maxWidth: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  boxSizing: "border-box",
                }}
              >
                <Box sx={{ flexGrow: 1 }} />
                {tabdata.find((obj) => obj.tab === value) ? (
                  <Form
                    form={form}
                    component={false}
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      maxWidth: "100%",
                    }}
                  >
                    <ConfigProvider
                      theme={{
                        token: {
                          borderRadius: 0,
                          colorText: "var(--grey-variation-tablerowsLK)",
                          colorTextHeading: "var(--grey-variation-tablerowsLK)",
                          fontSizeIcon: 10,
                          lineHeight: 1.5,
                        },
                        components: {
                          Table: {
                            colorBgContainer: "var(--SecondaryBackground)",
                            borderColor: "var(--table-boarder-line)",
                            headerBg: "var(--SecondaryBackground)",
                            headerSplitColor: "var(--SecondaryBackground)",
                            rowHoverBg: "var(--primary-background-color-hover)",
                            stickyScrollBarBg:
                              "var(--primary-background-color),var(--secondary-background)",
                            stickyScrollBarBorderRadius: 0,
                            cellPaddingBlockSM: "7.05px",
                            cellPaddingInlineSM: "7.1px",
                            width: "100%",
                            maxWidth: "100%",
                            boxSizing: "border-box",
                          },
                        },
                      }}
                      style={{
                        width: "100%",
                        boxSizing: "border-box",
                        maxWidth: "100%",
                      }}
                    >
                      <Table
                        components={{
                          body: {
                            cell: EditableCell,
                          },
                        }}
                        //rowSelection={rowSelection}
                        bordered={false}
                        tableLayout="fixed"
                        size="small"
                        pagination={false}
                        style={{
                          marginLeft: "2px",
                          marginRight: "2px",
                          marginTop: 0,
                          marginBottom: 0,
                          width: "99%",
                          maxWidth: "100%",
                          boxSizing: "border-box",
                          tableLayout: "fixed",
                          backgroundColor: "var(--SecondaryBackground)",
                        }}
                        dataSource={data}
                        columns={mergedColumns}
                        rowClassName={() => "editable-row"}
                        scroll={{
                          y: "300px",
                        }}
                      />
                    </ConfigProvider>
                  </Form>
                ) : (
                  <></>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};

SubTabs.propTypes = {
  cardHeading: PropTypes.string.isRequired, // cardHeading must be a string and required
  tablist: PropTypes.array.isRequired, // tablist must be an array and required
  selectedTab: PropTypes.oneOfType([
    // selectedTab can be a string or number
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  tabdata: PropTypes.object.isRequired, // tabdata must be an object and required
  editState: PropTypes.bool.isRequired, // editState must be a boolean and required
  rowData: PropTypes.array.isRequired, // rowData must be an array and required
  colData: PropTypes.array.isRequired, // colData must be an array and required
};
export default SubTabs;
